(function () {
  function moneyFormat() {
    var el = document.querySelector('[data-money-format]');
    return (el && el.getAttribute('data-money-format')) || '${{amount}}';
  }

  function formatMoney(cents) {
    var format = moneyFormat();
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var negative = cents < 0;
    var abs = Math.abs(Math.round(cents));
    var value;
    if (key === 'amount_no_decimals') {
      value = String(Math.round(abs / 100));
    } else if (key === 'amount_no_decimals_with_comma_separator') {
      value = String(Math.round(abs / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else if (key === 'amount_with_comma_separator') {
      value = (abs / 100).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    } else if (key === 'amount_with_space_separator') {
      value = (abs / 100).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    } else if (key === 'amount_with_apostrophe_separator') {
      value = (abs / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
    } else {
      var parts = (abs / 100).toFixed(2).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      value = parts.join('.');
    }
    var out = format.replace(/\{\{\s*\w+\s*\}\}/, value);
    return negative ? '-' + out : out;
  }

  function isTenPercent(app) {
    if (!app) return false;
    var type = String(app.value_type || '').toLowerCase();
    var value = parseFloat(app.value);
    var title = String(app.title || '');
    if (type === 'percentage' && !isNaN(value) && Math.abs(value - 10) < 0.051) return true;
    return /10\s*%/.test(title);
  }

  function savingsFromCart(cart) {
    var qty = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var merch = cart && typeof cart.original_total_price === 'number' ? cart.original_total_price : 0;
    var appliedCents = 0;
    var applied = false;
    var apps = (cart && cart.cart_level_discount_applications) || [];
    var i;
    var j;
    var k;
    for (i = 0; i < apps.length; i++) {
      if (isTenPercent(apps[i])) {
        applied = true;
        appliedCents += apps[i].total_allocated_amount || 0;
      }
    }
    var items = (cart && cart.items) || [];
    for (j = 0; j < items.length; j++) {
      var lines = items[j].line_level_discount_allocations || [];
      for (k = 0; k < lines.length; k++) {
        var alloc = lines[k];
        if (isTenPercent(alloc.discount_application)) {
          applied = true;
          appliedCents += alloc.amount || 0;
        }
      }
    }
    if (!applied && cart && cart.total_discount > 0 && merch > 0) {
      var expected = Math.round(merch * 0.1);
      var diff = Math.abs(cart.total_discount - expected);
      var tol = Math.max(qty, 5, Math.round(expected * 0.02));
      if (diff <= tol) {
        applied = true;
        appliedCents = cart.total_discount;
      }
    }
    return {
      qty: qty,
      applied: applied,
      cents: applied ? appliedCents : Math.round(merch * 0.1)
    };
  }

  function paintDrawerPrices(cart) {
    var qty = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var model = savingsFromCart(cart || {});
    var merch = cart && typeof cart.original_total_price === 'number' ? cart.original_total_price : 0;
    var show = qty >= 2 && model.cents > 0;
    var due = Math.max(0, merch - model.cents);
    var rows = document.querySelectorAll('[data-sale-offer]');
    var i;
    for (i = 0; i < rows.length; i++) {
      rows[i].hidden = !show;
      var amt = rows[i].querySelector('[data-sale-offer-amt]');
      if (amt) amt.textContent = show ? formatMoney(-model.cents) : '';
    }
    if (!show) return;
    var drawerTotal = document.getElementById('v_subTotal');
    if (drawerTotal) drawerTotal.textContent = formatMoney(due);
    var cartTotal = document.getElementById('stotal');
    if (cartTotal) cartTotal.textContent = formatMoney(due);
  }

  function drawerQty(cart) {
    if (cart && typeof cart.item_count === 'number') return cart.item_count;
    var rows = document.querySelectorAll('#v_cartItems .product-row');
    var total = 0;
    var i;
    for (i = 0; i < rows.length; i++) {
      var input = rows[i].querySelector('.qty_input');
      var qty = input ? parseInt(input.value, 10) : parseInt(rows[i].getAttribute('data-qty'), 10);
      if (!isNaN(qty)) total += qty;
    }
    return total;
  }

  function paintDrawerNudge(cart) {
    var show = drawerQty(cart) >= 1;
    var nudges = document.querySelectorAll('[data-sale-nudge]');
    var i;
    for (i = 0; i < nudges.length; i++) nudges[i].hidden = !show;
  }

  window.applyBuy2DrawerPrices = function (cart) {
    var source = cart && Array.isArray(cart.items) ? cart : window.__buy2LastCart;
    if (source) {
      paintDrawerNudge(source);
      paintDrawerPrices(source);
      return;
    }
    window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (fresh) {
        window.__buy2LastCart = fresh;
        paintDrawerNudge(fresh);
        paintDrawerPrices(fresh);
      })
      .catch(function () {});
  };

  function paintSale(root, model) {
    var next = model.qty <= 0 ? '0' : (model.qty === 1 ? '1' : '2');
    var lines = root.querySelectorAll('[data-sale-line]');
    var counts = root.querySelectorAll('[data-sale-count]');
    var amounts = root.querySelectorAll('[data-buy2-amount]');
    var i;
    root.setAttribute('data-state', next);
    for (i = 0; i < lines.length; i++) {
      lines[i].hidden = lines[i].getAttribute('data-sale-line') !== next;
    }
    for (i = 0; i < counts.length; i++) {
      counts[i].hidden = counts[i].getAttribute('data-sale-count') !== next;
    }
    for (i = 0; i < amounts.length; i++) amounts[i].textContent = formatMoney(model.cents);
  }

  function paintPair(raw) {
    var el = document.querySelector('[data-pdp-pair-amt]');
    if (!el || !raw) return;
    var dollars = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    if (!dollars) return;
    var cents = Math.round(dollars * 100);
    var pair = cents - Math.round(cents * 0.1);
    el.textContent = formatMoney(pair);
  }

  document.addEventListener('click', function (event) {
    var node = event.target;
    while (node && node !== document) {
      if (node.getAttribute && node.getAttribute('data-id') && node.closest && node.closest('#size-pick')) {
        paintPair(node.getAttribute('data-vprice-orig') || node.getAttribute('data-vprice'));
        break;
      }
      node = node.parentNode;
    }
  });

  window.syncBuy2Save10 = function (cart) {
    if (!cart || typeof cart.item_count !== 'number' || !Array.isArray(cart.items)) return;
    window.__buy2LastCart = cart;
    var model = savingsFromCart(cart);
    var nodes = document.querySelectorAll('[data-buy2-save10]');
    var i;
    for (i = 0; i < nodes.length; i++) paintSale(nodes[i], model);
    if (window.applyBuy2DrawerPrices) window.applyBuy2DrawerPrices(cart);
  };

  var refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshTimer = null;
      window.fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { window.syncBuy2Save10(cart); })
        .catch(function () {});
    }, 40);
  }

  function maybeCart(url, bodyText) {
    if (!url || !/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/.test(String(url))) return;
    var data = null;
    try { data = JSON.parse(bodyText); } catch (error) { data = null; }
    if (data && typeof data.item_count === 'number' && Array.isArray(data.items)) {
      window.syncBuy2Save10(data);
      return;
    }
    scheduleRefresh();
  }

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|#|$)/.test(String(url))) {
        result.then(function (response) {
          return response.clone().text().then(function (text) {
            maybeCart(url, text);
          });
        }).catch(function () {});
      }
      return result;
    };
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__buy2Url = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300) {
        maybeCart(this.__buy2Url, this.responseText);
      }
    });
    return originalSend.apply(this, arguments);
  };
})();
